import React, { useEffect } from "react"
import { graphql } from "gatsby"
import Layout from "../components/Layout"
import MapTo from "../utils/mapto"
import { documentToPlainTextString } from "@contentful/rich-text-plain-text-renderer"
import useSiteMetadata from '@hooks/useSiteMetadata';

const ContentfulPage = ({ data }) => {
  const { contentfulPageHcp } = data
  
  return (
    <Layout backgroundColor={contentfulPageHcp?.backgroundColor} isi={{ isi: contentfulPageHcp?.isi, importantSafetyInformation: contentfulPageHcp?.importantSafetyInformation, indication: contentfulPageHcp?.indication }} references={contentfulPageHcp?.references} isEfficacyPage={true}>
      {contentfulPageHcp?.content?.map(item => <MapTo key={item.id} items={item}></MapTo>)}
	</Layout>
  )
}


export const query = graphql`
  query($id: String!) {
    contentfulPageHcp(id: { eq: $id }) {
      id
      entryTitle
      pageTitle
      pageDescription{
		__typename
        raw
      }
      slug
      backgroundColor
      header
        content {
            ...ContentfulPageContentItemFragment
        }
        isi{
            ...ContentfulRichTextFragment
        }
        references{
            ...ContentfulRichTextFragment
        }
        importantSafetyInformation{
          ...ContentfulRichTextFragment
        }
        indication{
          ...ContentfulRichTextFragment
        }
        header
    }
  }
`

export default ContentfulPage 

export const Head = ({ data, location }) => {
  const contentfulPageHcp = data.contentfulPageHcp;
  const title = contentfulPageHcp?.pageTitle || "Default Title";

  const description =
  contentfulPageHcp?.pageDescription?.raw
    ? documentToPlainTextString(JSON.parse(contentfulPageHcp.pageDescription.raw))
    : "Default description";
  
  const { siteUrl } = useSiteMetadata();

  const canonicalUrl = `${siteUrl}${location.pathname || ''}`;

  return (
    <>
      <title>{title}</title>
	  <meta name="title" content={title} />
      <meta name="description" content={description} />
	  <meta property="og:title" content={title} />
	  <meta property="og:description" content={description} />
	  <meta property="og:site_name" content="EXPAREL® (bupivacaine liposome injectable suspension) for HCPs" />
	  <meta name="twitter:title" content={title} />
	  <meta name="twitter:description" content={description} />
	  <link rel="canonical" href={canonicalUrl} />
    </>
  )
}